import { render } from "./EditPays.vue?vue&type=template&id=2afe72e0"
import script from "./EditPays.vue?vue&type=script&lang=js"
export * from "./EditPays.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__